export default __webpack_public_path__ + "img/weiboa.44cf0cf4.svg";